<span class="shipment_name">{{ params.value }}</span>
<span class="shipment_link" *ngIf="selectedAccountType != 'walmart'">
  <a
    target="_blank"
    href="https://amazon.com/sp?seller={{ this.params.value }}"
    (click)="stopPropagation($event)"
  >
    <i _ngcontent-rll-c231="" class="fal fa-external-link-square-alt"></i
  ></a>
</span>
